import { storageDateFormat } from '@/core';
import { orderFilter } from '@/dataStructures';
import deepCopy from 'deepcopy';
import moment from 'moment';
import Decimal from 'decimal.js';
import searchFilterMutations from './searchFilter/orderSearch.mutations.js';

let setValue = (state, { value, key }) => {
	state[key] = value;
};

function processOrders(orders) {
	let processedOrders = [];
	for (let order of orders) {
		if (order.leaveUnplanned) continue;
		if (order.freightLines)
			order.numberOfPallets = order.freightLines.reduce((p, c) => p.plus(c.numberOfPallets), new Decimal(0)).toNumber();
		processedOrders.push(order);
	}
	return processedOrders;
}
let setOrders = (state, response) => {
	state.orders = processOrders(response);
};

let updateMatchingOrders = (state, orders) => {
	let refreshedOrders = processOrders(orders);
	for (let order of refreshedOrders) {
		let index = state.orders.findIndex(x => x.id === order.id);
		if (index > -1)
			state.orders[index] = order;
		else
			state.orders.push(order);
	}
};

let clearOrders = (state) => {
	state.orders = [];
	state.totals.orders = 0;
	state.totals.volume = 0;
	state.totals.weight = 0;
	state.totals.loadingMeters = 0;
	state.totals.totalPrice = 0;
};

let setTotals = (state, totals) => {
	state.totals.orders = totals.count;
	state.totals.volume = totals.volume;
	state.totals.weight = totals.grossWeight;
	state.totals.loadingMeters = totals.loadingMeters;
	state.totals.totalPrice = totals.totalPrice;
	state.totals.baseCurrency = totals.baseCurrency || 'NOK';
};

let loadSavedSearch = (state, savedSearch) => {
	if (!savedSearch) return;

	state.loadedSearch = savedSearch;

	if (savedSearch.id === -1) { // reset
		state.searchFilter = orderFilter();
		state.loadedSearch = { id:-1, labelKey: 'searchForOrders' };
	} else {
		if (savedSearch.timeInterval.before) {
			let date = moment().add(savedSearch.timeInterval.before,'d').startOf('day');
			state.searchFilter.date.from = date.format(storageDateFormat);
		}
		if (savedSearch.timeInterval.after) {
			let date = moment().add(savedSearch.timeInterval.after,'d').endOf('day');
			state.searchFilter.date.to = date.format(storageDateFormat);
		}
		state.searchFilter.dateType = deepCopy(savedSearch.dateType) || 'etd';
		state.searchFilter.fromDespatchParty = deepCopy(savedSearch.fromDespatchParty || []);
		state.searchFilter.toDeliveryParty = deepCopy(savedSearch.toDeliveryParty || []);
		state.searchFilter.customer = deepCopy(savedSearch.customer || []);
		state.searchFilter.goodsTypes = deepCopy(savedSearch.goodsTypes || []);
		state.searchFilter.orderTypes = deepCopy(savedSearch.orderTypes || []);
		state.searchFilter.hasAtd = deepCopy(savedSearch.hasAtd || { value: undefined, label: 'showAny' });
		state.searchFilter.hasAta = deepCopy(savedSearch.hasAta || { value: undefined, label: 'showAny' });
		state.searchFilter.economicalStatus = deepCopy(savedSearch.economicalStatus || []);
		state.searchFilter.orderStatus = deepCopy(savedSearch.orderStatus || []);
		state.searchFilter.references = deepCopy(savedSearch.references || []);
		state.searchFilter.referencesText = deepCopy(savedSearch.referencesText) || '';
		state.searchFilter.waybillNumber = deepCopy(savedSearch.waybillNumber || []);
		state.searchFilter.mustHaveInboundEdi = savedSearch.mustHaveInboundEdi;
		state.searchFilter.inboundEdi = savedSearch.inboundEdi || '';
		state.searchFilter.mustHaveDeviation = savedSearch.mustHaveDeviation;
	}
};

let setOrderDetails = (state, orderId) => {
	let order = state.orders.find(({ id }) => id === orderId);
	if (!order) return;
	state.orderDetails = order;
};

let setOrderJsonId = (state, orderId) => {
	state.orderJsonId = orderId;
};

export default {
	setValue,
	setOrders,
	updateMatchingOrders,
	clearOrders,
	setTotals,
	loadSavedSearch,
	setOrderDetails,
	setOrderJsonId,
	...searchFilterMutations,
};
